<template>
  <ul class="u u_sh">
    <li v-for="item in list" :key="item.id" :class="item.dataList && item.dataList.length > 1 ? 'li-more' : ''">
      <template v-if="!item.dataList || item.dataList.length <= 1">
        <div @click="goTo(item)">
          <div class="fl">{{ item.name }}</div>
          <i class="iC i_tip"></i> <i class="iC i_jt2"></i>
        </div>
      </template>
      <template v-else>
        <ul>
        <li v-for="citem in item.dataList" :key="citem.id" class="div1"  @click="goTo(item, citem.id)">
          <div class="fl">{{ item.name }}</div>
          <i class="iC i_tip"></i> <i class="iC i_jt2"></i>
          <div class="fl fl-c">{{ citem.company }}</div>
        </li>
        </ul>
      </template>
    </li>
  </ul>
</template>
<script>
import { getStatusName, setLocal } from "@/common/js";
import { useRouter } from "vue-router";
export default {
  props: {
    list: Array,
    type: Number,
    status: {
      type: Number,
      default: 0,
    },
  },
  // type: 1未填写填写页面，2详情页面
  setup(props) {
    const router = useRouter();
    // item.id, item.dataList,
    const goTo = (item, cid = '') => {
      console.log('item--', item.id);
      let tipTxt = '建设情况'
      switch (item.id) {
        case 14:
          tipTxt = '少先队校外实践教育校外营地（基地）建设情况'
          break;
        case 23:
        case 24:
          tipTxt = '外系统青少宫及社区（街道、乡镇、村）建设情况'
          break;
        case 30:
        case 31:
          tipTxt = '团属青少年宫建设情况'
          break;
        case 37:
          tipTxt = '少先队省（自治区、直辖市）、市（地、州、盟）、县（区、旗）总辅导员信息统计项'
          break;
      }
      const { type } = props;
      const { id, dataList, vueUrl, audit } = item;
      const _url = type == 1 ? "/add" : "/detail";
      const _form = "/form" + (parseInt(id) - 1);
      const _host = "/info" + _url + _form;
      // 和2022寒假表单相同
      const otherId = 32
      const excludedIds = [37, 38, 39, 40, 41];
      // 新增
      if (!dataList) {
        // 表单8 以后使用的是动态表单
        if (id > 7 && id != otherId && !excludedIds.includes(id)) {
            const backUrl = window.location.href
            // k618_form_goback 返回跳转地址
            setLocal("k618_form_goback", backUrl);
            window.location.href = vueUrl + "?type=0&audit="+audit+'&tipTxt='+tipTxt;
        } else {
          router.push({ path: _host });
        }
        return false;
      }

      // 编辑
      if (id > 7 && id != otherId && !excludedIds.includes(id)) {
        const backUrl = window.location.href
         // k618_form_goback 返回跳转地址
        setLocal("k618_form_goback", backUrl);
        if (dataList.length <= 1) {
          window.location.href = vueUrl + "?type=2&dataId=" + dataList[0].id+'&audit='+audit+'&tipTxt='+tipTxt;
        } else {
          window.location.href = vueUrl + "?type=2&dataId=" + cid+'&audit='+audit+'&tipTxt='+tipTxt;
        }
      } else if (id == 5 || id == 4) {
        router.push({ path: "/info/detail/form4", query: { id: id } });
      } else {
        // 详情
        router.push({ path: _host, query: { id: dataList[0].id } });
      }
    };
    return {
      getStatusName,
      goTo,
    };
  },
};
</script>
<style lang="less" scoped>
@import "@/common/style/mixin";
.u_sh li {
  display: list-item;
  height: auto;
}
.u_sh .fl {
  width: 90%;
  height: auto;
}
.div1 {
  display: inline-block;
  padding: 0.4rem 0.4rem 0.4rem 0.533rem;
  margin: 0.133rem 0.133rem 0.4rem;
  height: 2.4rem;
  background: #fff;
  border-radius: 0.16rem;
  -webkit-box-shadow: 0 0 0.133rem rgb(255 154 152 / 20%);
  box-shadow: 0 0 0.133rem rgb(255 154 152 / 20%);
}
.li-more {
  background: none;
  padding: 0;
  box-shadow: none;
}
.fl-c {
    font-size: 0.38rem;
    margin-top: 0.3rem;
    font-weight: normal;
}
</style>
